"use client";

import React, { useState } from "react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
const services = [{
  title: "Gel Manicure — £35",
  path: "/BeautyPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/gel_manicure.png",
  description: "Precision shaping and long-lasting color for a flawless finish."
}, {
  title: "BIAB Overlay — £45",
  path: "/BeautyPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/biab_nails.png",
  description: "Builder in a Bottle for natural nail strength and durability."
}, {
  title: "Lash Lift & Tint — £55",
  path: "/BeautyPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/lash_lift.png",
  description: "Enhance your natural lashes with a semi-permanent curl."
}, {
  title: "Brow Sculpt — £25",
  path: "/BeautyPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/brow_sculpt.png",
  description: "Defined, symmetrical brows tailored to your unique face shape."
}, {
  title: "Luxury Pedicure — £40",
  path: "/BeautyPage",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/pedicure.png",
  description: "Ultimate relaxation and intensive foot rejuvenation."
}];
const defaultImage = "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/botox_treatment.png";
export default function ServicesOverview() {
  const [activeImage, setActiveImage] = useState(defaultImage);
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="39527" id="beauty-services" ref={ref} className="relative bg-background text-foreground py-[160px] overflow-hidden">
      {}
      <style>{`
        @keyframes slow-drift {
          0% { transform: translateX(0); }
          100% { transform: translateX(-5%); }
        }
        .animate-slow-drift {
          animation: slow-drift 30s linear infinite alternate;
        }
      `}</style>

      {}
      <div className="absolute top-1/2 left-0 w-full -translate-y-1/2 pointer-events-none select-none overflow-hidden z-0 opacity-5">
        <div className="animate-slow-drift whitespace-nowrap">
          <span className="font-serif text-[200px] leading-none text-foreground tracking-tighter">
            BEAUTY BEAUTY
          </span>
        </div>
      </div>

      <div className={cn("container mx-auto px-6 relative z-10 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24 items-center">
          {}
          <div className="lg:col-span-7 flex flex-col gap-10" onMouseLeave={() => setActiveImage(defaultImage)}>
            {services.map((service, i) => <div key={i} data-index={i} onMouseEnter={() => setActiveImage(service.image)} className="group flex items-center justify-between w-full">
                <Link to={service.path} className="relative inline-block py-2 group/link">
                  <span className="font-serif text-[24px] font-light text-foreground relative z-10">
                    {service.title}
                  </span>
                  {}
                  <span className="absolute bottom-0 left-0 h-[1px] w-0 bg-ring transition-all duration-300 ease-out group-hover/link:w-full" />
                </Link>

                {}
                <ArrowRight className="text-ring opacity-0 -translate-x-4 transition-all duration-300 group-hover:opacity-100 group-hover:translate-x-0" />
              </div>)}
          </div>

          {}
          <div className="lg:col-span-5">
            <div className="relative aspect-[4/5] w-full border border-ring/20 bg-muted shadow-xl overflow-hidden">
              {}
              <img src={defaultImage} alt="Botox Treatment" className={cn("absolute inset-0 w-full h-full object-cover transition-opacity duration-600 ease-in-out", activeImage === defaultImage ? "opacity-100" : "opacity-0")} />

              {}
              {services.map((service, i) => <img key={i} src={service.image} alt={service.title} className={cn("absolute inset-0 w-full h-full object-cover transition-opacity duration-600 ease-in-out", activeImage === service.image ? "opacity-100" : "opacity-0")} />)}

              {}
              <div className="absolute inset-0 bg-background/20 pointer-events-none mix-blend-multiply" />

              {}
              <div className="absolute inset-0 border border-foreground/5 pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}